import { API_ROUTES } from "./apiRoutes";
import api from "./axiosInstance";

export const getDashbordDetails = async (data) => {
  const res = await api.post(API_ROUTES.DASHBOARD.LIST, data);
  return res.data;
};
